import {Badge, Col, Row, Spinner} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, {useEffect, useState} from "react";
import {
  getCMFWListInfo, getCMFWListInfoRead,
  modCmfwSt,
  regCmfwSt
} from "../../api/apiClient";
import Swal from "sweetalert2";
import PopUp from "../popUp/PopUp";
import StatusInfo from "../../pages/subPages/StatusInfo";
import ComboDistrict from "../inputs/ComboDistrict";
import DatePicker from "react-date-picker";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import "../../layout/styles/components/date-picker.scss";
import Moment from "moment";
import AxcBadge from "../common/AxcBadge";


const CMFWInfoBox = ({
                       propFcltyID,
                       propIsReadOnly = false,
                       setShow,
                       updateList,
                       propLocation = "dash"
                     }) => {

  const [facilityInfo, setFacilityInfo] = useState({});
  const [isModified, setIsModified] = useState(false);

  useEffect(() => {
    console.log(facilityInfo);
  }, [facilityInfo]);

  const updateFacilityInfo = () => {
    if (propFcltyID != null && propFcltyID !== 0) {
      if (propIsReadOnly) {
        getCMFWListInfoRead(propFcltyID).then(response => {
          if (response.data.data !== undefined) {
            console.log(response);
            setFacilityInfo(response.data.data.facilityInfo);
          }
        });
      } else {
        getCMFWListInfo(propFcltyID).then(response => {
          if (response.data.data !== undefined) {
            console.log(response);
            setFacilityInfo(response.data.data);
          }
        });
      }
    }
  };

  const onChangeInfo = (name, value, isMany = false) => {
    let newInfo = {...facilityInfo};
    if (isMany) {
      for (let i = 0; i < name.length; i++) {
        newInfo[name[i]] = value[i];
      }
    } else {
      newInfo[name] = value;
    }
    setFacilityInfo(newInfo);
    setIsModified(true);
  };


  const onSubmitFacilityForm = () => {
    // 현재 input 모아서 API PUT

    if (!facilityInfo.atdrc_id) {
      Swal.fire(
          '지역은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!facilityInfo.fclty_nm) {
      Swal.fire(
          '시설명은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!facilityInfo.locplc_addr) {
      Swal.fire(
          '소재지는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!facilityInfo.locplc_lo) {
      Swal.fire(
          '위도는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!facilityInfo.locplc_la) {
      Swal.fire(
          '경도는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!facilityInfo.elvtr_ennc_yn) {
      Swal.fire(
          '엘리베이터는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!facilityInfo.pic_nm) {
      Swal.fire(
          '관리자는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!facilityInfo.pic_telno) {
      Swal.fire(
          '연락처는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!facilityInfo.instl_de) {
      Swal.fire(
          '설치일은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }


    if (propFcltyID === 0) {
      // 등록
      regCmfwSt(facilityInfo)
          .then(res => {
            // console.log(res);
            if (res.data.data !== undefined) {
              // console.log(res.data.data);
              Swal.fire(
                  '정상적으로 처리 되었습니다!',
                  '',
                  'success'
              );
              setShow();
              updateList();
            }
          })
          .catch(err => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    } else {
      // 수정
      modCmfwSt(facilityInfo)
          .then(res => {
            if (res.data.data !== undefined) {
              // console.log(res.data.dassta);
              Swal.fire(
                  '정상적으로 처리 되었습니다!',
                  '',
                  'success'
              );
            }
          })
          .catch(err => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    }
    setIsModified(false);
  };

  useEffect(() => {
    updateFacilityInfo();
  }, [])

  /* 팝업을 위한 state */
  const [openPopup, setPopup] = useState({isVisible: false, user_id: 0});

  const closePopup = () => {
    setPopup({isVisible: false, user_id: 0});
  }

  const handleOpenPopup = (e = null) => {
    setPopup({
      isVisible: true,
      user_id: e.target.dataset.id,
    });
  };

  const onChangeDate = (date) => {
    // console.log(date);
    // console.log(new Date(date));
    // console.log(Moment(date).format('YYYY-MM-DD'));
    onChangeInfo('instl_de', Moment(date).format('YYYY-MM-DD'));
    // onChangeInfo('instl_de', new Date(date));
  };

  return (
      <>
        <PopUp
            propTitle={'게이트웨이 상태 정보'}
            propShow={openPopup.isVisible}
            setShow={closePopup}
        >
          {/*게이트웨이*/}
          <StatusInfo
              propType={'gateway'}
              propName={'게이트웨이'}
              propFcltyID={propFcltyID}
          />
        </PopUp>
        <Row className={'info-container py-2'}>
          <Col md={11} className={''}>
            <div className={'content-container-body-item'}>
              <Form
                  className={'mobile-weak-facilities-info-form py-1'}
                  id={'mobileWeakFacilitiesInfoForm'}
              >
                <Row className={"gy-2"}>
                  {/*<Col md={3}>*/}
                  <Col xxl={3} xl={4} lg={4} md={6}>
                    <ComboDistrict
                        propLabel={"자치구"}
                        // propRatio={4}
                        propIsSearch={false}
                        propOnChange={(e) => {
                          onChangeInfo('atdrc_id', e.target.value);
                        }}
                        propValue={facilityInfo.atdrc_id || 'atdrc_id'}
                        propLocation={propLocation === "dash" ? "SEARCH" : "FIELD"}
                    />
                  </Col>

                  {/*<Col md={3}>*/}
                  <Col xxl={3} xl={4} lg={4} md={6}>
                    <Form.Group as={Row} controlId="formFacilityName">
                      {/*<Form.Label column md={4}
                                  className={`label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}
                      >*/}
                      <Form.Label
                          className={`col-form-label label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}
                          style={{width: "100px"}}
                      >
                        {propLocation === "dash" ? "" : <span className={"text-danger"}>* </span>}시설명
                      </Form.Label>
                      <Col>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            // key={facilityInfo.fclty_nm || 'fclty_nm'}
                            // defaultValue={facilityInfo.fclty_nm || ''}
                            value={facilityInfo.fclty_nm || ''}
                            onChange={(e) => {
                              onChangeInfo('fclty_nm', e.target.value)
                            }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col xxl={3} xl={4} lg={4} md={6}>
                    <Form.Group as={Row} controlId='formFloorInfo'>
                      {/*<Form.Label column md={4} className={'label text-end'}>*/}
                      <Form.Label
                          className={`col-form-label label text-end`}
                          style={{width: "100px"}}
                      >
                        층수(규모)
                      </Form.Label>
                      <Col>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            // key={facilityInfo.strct || 'strct'}
                            // defaultValue={facilityInfo.strct || ''}
                            value={facilityInfo.strct || ''}
                            onChange={(e) => {
                              onChangeInfo('strct', e.target.value)
                            }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  {/*<Col md={3}>
                    <Form.Group as={Row} controlId='formFloorInfo'>
                      <Form.Label column md={4}
                                  className={`label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}>
                        {propLocation === "dash" ? "" : <span className={"text-danger"}>* </span>}층수(지상/지하)
                      </Form.Label>
                      <Col md={8}>
                        <Row>
                          <Col md={4}>
                            <Form.Control
                                type='text'
                                className={'input text-white'}
                                defaultValue={facilityInfo.grnd_nofl || ''}
                                onChange={(e) => {
                                  onChangeInfo('grnd_nofl', e.target.value)
                                }}
                            />
                          </Col>
                          <Form.Label column md={2} className={'label text-center'}>
                            F /
                          </Form.Label>
                          <Col md={4}>
                            <Form.Control
                                type='text'
                                className={'input text-white'}
                                defaultValue={facilityInfo.udgd_nofl || ''}
                                onChange={(e) => {
                                  onChangeInfo('udgd_nofl', e.target.value)
                                }}
                            />
                          </Col>
                          <Form.Label column md={2} className={'label text-start'}>
                            B
                          </Form.Label>
                        </Row>
                      </Col>
                    </Form.Group>
                  </Col>*/}

                  <Col xxl={3} xl={4} lg={4} md={6}>
                    <Form.Group as={Row} controlId='formLocplcAddr'>
                      {/*<Form.Label
                          column md={4}
                          className={`label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}
                      >*/}
                      <Form.Label
                          className={`col-form-label label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}
                          style={{width: "100px"}}
                      >
                        {propLocation === "dash" ? "" : <span className={"text-danger"}>* </span>}소재지
                      </Form.Label>
                      <Col>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            // key={facilityInfo.locplc_addr || 'locplc_addr'}
                            // defaultValue={facilityInfo.locplc_addr || ''}
                            value={facilityInfo.locplc_addr || ''}
                            onChange={(e) => {
                              onChangeInfo('locplc_addr', e.target.value)
                            }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  {/*<Col md={3}>*/}
                  <Col xxl={3} xl={4} lg={4} md={6}>
                    <Form.Group as={Row} controlId='formFloorInfo'>
                      {/*<Form.Label column md={4}
                                  className={`label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}>*/}
                      <Form.Label
                          className={`col-form-label label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}
                          style={{width: "100px"}}
                      >
                        {propLocation === "dash" ? "" : <span className={"text-danger"}>* </span>}위도/경도
                      </Form.Label>
                      <Col>
                        <Row>
                          <Col>
                            <Form.Control
                                type='text'
                                className={'input text-white'}
                                // key={facilityInfo.locplc_lo || 'locplc_lo'}
                                // defaultValue={facilityInfo.locplc_lo || ''}
                                value={facilityInfo.locplc_lo || ''}
                                onChange={(e) => {
                                  onChangeInfo('locplc_lo', e.target.value)
                                }}
                            />
                          </Col>
                          <Form.Label column md={2} className={'label text-center'}>
                            /
                          </Form.Label>
                          <Col>
                            <Form.Control
                                type='text'
                                className={'input text-white'}
                                // key={facilityInfo.locplc_la || 'locplc_la'}
                                // defaultValue={facilityInfo.locplc_la || ''}
                                value={facilityInfo.locplc_la || ''}
                                onChange={(e) => {
                                  onChangeInfo('locplc_la', e.target.value)
                                }}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col xxl={3} xl={4} lg={4} md={6}>
                    <Form.Group as={Row} controlId='formEvInfo'>
                      {/*<Form.Label column md={4}
                                  className={`label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}>*/}
                      <Form.Label
                          className={`col-form-label label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}
                          style={{width: "106px"}}
                      >
                        {propLocation === "dash" ? "" : <span className={"text-danger"}>* </span>}엘리베이터
                      </Form.Label>
                      <Col>
                        <Form.Select
                            aria-label="Default select example"
                            className={"input input-select"}
                            // key={facilityInfo.elvtr_ennc_yn || ''}
                            // defaultValue={facilityInfo.elvtr_ennc_yn || ''}
                            value={facilityInfo.elvtr_ennc_yn || ''}
                            onChange={(e) => {
                              onChangeInfo('elvtr_ennc_yn', e.target.value)
                            }}
                        >
                          <option value={""}>선택</option>
                          <option key={"Y"} value={"Y"}>있음</option>
                          <option key={"N"} value={"N"}>없음</option>
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>

                  {/*<Col md={3}>
                    <Form.Group as={Row} controlId='formPuloutInfo'>
                      <Form.Label column md={4}
                                  className={`label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}>
                        {propLocation === "dash" ? "" : <span className={"text-danger"}>* </span>}대피로 정보
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            defaultValue={facilityInfo.pulout_info || ''}
                            onChange={(e) => {
                              onChangeInfo('pulout_info', e.target.value)
                            }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>*/}

                  {/*<Col md={3}>
                    <Form.Group as={Row} controlId='formWallMtrqlt'>
                      <Form.Label column md={4} className={'label text-end'}>벽/천정 재질</Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            defaultValue={facilityInfo.wall_mtrqlt || ''}
                            onChange={(e) => {
                              onChangeInfo('wall_mtrqlt', e.target.value);
                            }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>*/}

                  {/*<Col md={3}>
                    <Form.Group as={Row} controlId='formFcltyPrpos'>
                      <Form.Label column md={4} className={'label text-end'}>시설용도</Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            defaultValue={facilityInfo.fclty_prpos || ''}
                            onChange={(e) => {
                              onChangeInfo('fclty_prpos', e.target.value)
                            }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>*/}

                  <Col xxl={6} xl={12} lg={12} md={12}>
                    <Form.Group as={Row} controlId='formUseSttus'>
                      {/*<Form.Label column md={2} className={'label text-end'}>*/}
                      <Form.Label
                          className={`col-form-label label text-end`}
                          style={{width: "100px"}}
                      >
                        이용현황
                      </Form.Label>
                      <Col>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            // key={facilityInfo.use_sttus || 'use_sttus'}
                            // defaultValue={facilityInfo.use_sttus || ''}
                            value={facilityInfo.use_sttus || ''}
                            onChange={(e) => {
                              onChangeInfo('use_sttus', e.target.value)
                            }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  {/*<Col md={3}>*/}
                  <Col xxl={3} xl={4} lg={4} md={6}>
                    <Form.Group as={Row} controlId='formPicNm'>
                      {/*<Form.Label column md={4}
                                  className={`label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}>*/}
                      <Form.Label
                          className={`col-form-label label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}
                          style={{width: "100px"}}
                      >
                        {propLocation === "dash" ? "" : <span className={"text-danger"}>* </span>}관리자
                      </Form.Label>
                      <Col>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            // key={facilityInfo.pic_nm || 'pic_nm'}
                            // defaultValue={facilityInfo.pic_nm || ''}
                            value={facilityInfo.pic_nm || ''}
                            onChange={(e) => {
                              onChangeInfo('pic_nm', e.target.value)
                            }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  {/*<Col md={3}>*/}
                  <Col xxl={3} xl={4} lg={4} md={6}>
                    <Form.Group as={Row} controlId='formPicTelno'>
                      {/*<Form.Label column md={4}
                                  className={`label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}>*/}
                      <Form.Label
                          className={`col-form-label label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}
                          style={{width: "100px"}}
                      >
                        {propLocation === "dash" ? "" : <span className={"text-danger"}>* </span>}연락처
                      </Form.Label>
                      <Col>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            // key={facilityInfo.pic_telno || 'pic_telno'}
                            // defaultValue={facilityInfo.pic_telno || ''}
                            value={facilityInfo.pic_telno || ''}
                            onChange={(e) => {
                              onChangeInfo('pic_telno', e.target.value)
                            }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  {/*<Col md={3}>*/}
                  <Col xxl={3} xl={4} lg={4} md={6}>
                    <Form.Group as={Row} controlId='formInstlDe'>
                      {/*<Form.Label column md={4}
                                  className={`label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}>*/}
                      <Form.Label
                          className={`col-form-label label text-end ${propLocation === "dash" ? "" : "fw-bold"}`}
                          style={{width: "100px"}}
                      >
                        {propLocation === "dash" ? "" : <span className={"text-danger"}>* </span>}설치일
                      </Form.Label>
                      <Col>
                        <DatePicker
                            onChange={(date) => {
                              // onChangeInfo('instl_de', new Date(date));
                              onChangeDate(date);
                            }}
                            value={(facilityInfo.instl_de != null) ? new Date(facilityInfo.instl_de) : ''}
                            format={"yyyy-MM-dd"}
                            clearIcon={null}
                            className={"datepicker-start w-100 text-center"}
                            calendarType={'US'}
                            formatDay={
                              (locale, date) => new Intl.DateTimeFormat(
                                  'en-US',
                                  {
                                    day: "numeric"
                                  }).format(date)
                            }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
          {propIsReadOnly ?
              <Col md={1} className={'mobile-weak-facilities-info-save-container'}>
                {/*<img src={GateICON}/>*/}
                <Button
                    className={'mobile-weak-facilities-info-save w-75'}
                    onClick={handleOpenPopup}
                    // disabled={!isModified}
                >
                  {/*<Spinner animation="grow" variant="danger"
                           className={"position-absolute top-0 start-0 translate-middle p-2 bg-danger border border-light"}
                  />*/}
                  {/*<span>게이트웨이 <AxcBadge*/}
                  {/*       // propInput={facilityInfo.serius_level_nm}*/}
                  {/*       propInput={"Critical"}*/}
                  {/*       propDangerText={'Critical'}*/}
                  {/*       propWarningText={'Major'}*/}
                  {/*       propMinorWarningText={'Minor'}*/}
                  {/*   />*/}
                  {/*</span>*/}
                  <small>
                    게이트웨이
                  </small>
                  <span className={`position-absolute top-0 start-100 translate-middle badge rounded-pill 
                  ${facilityInfo.gtwy_serius_level == '3' ? 'bg-danger' : facilityInfo.gtwy_serius_level == '2' ? 'bg-major' : facilityInfo.gtwy_serius_level == '1' ? 'bg-warning' : 'bg-success'} 
                  `}>
                    {`${facilityInfo.gtwy_serius_level == '3' ? 'CR' : facilityInfo.gtwy_serius_level == '2' ? 'MA' : facilityInfo.gtwy_serius_level == '1' ? 'MN' : 'NM'}`}
                  </span>
                </Button>
              </Col> :
              <Col md={1} className={'mobile-weak-facilities-info-save-container'}>
                <Button
                    className={'mobile-weak-facilities-info-save w-75'}
                    onClick={onSubmitFacilityForm}
                    disabled={!isModified}
                >저장</Button>
              </Col>}
        </Row>
      </>

  );
}


export default CMFWInfoBox;